import { ViewCardRanking, TextStyledCardRanking, ViewSquarCardRanking } from "./Graphic";

interface GraphicInterface {
    title: string;
    ranking: number;
    valuePaddingTitle?: string
}

export default function Card({ title, ranking, valuePaddingTitle }: GraphicInterface) {
    return (
        <ViewCardRanking>
            <TextStyledCardRanking padding={valuePaddingTitle}>
                {title}
            </TextStyledCardRanking>
            <ViewSquarCardRanking>
                {`${ranking}`}
            </ViewSquarCardRanking>
        </ViewCardRanking>
    );
}